import { connect } from 'react-redux';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';
import CareGuidePartnerTagAdminEditScreen from '../components/CareGuidePartnerTagAdminEditScreen';

const mapStateToProps = (state) => {
  return {
    isLoading: state.careGuidePartnerTagsAdmin.get('isLoading'),
    success: state.careGuidePartnerTagsAdmin.getIn(['form', 'success']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const CareGuidePartnerTagAdminEditScreenContainer = connect(mapStateToProps)(
  CareGuidePartnerTagAdminEditScreen
);

export default CareGuidePartnerTagAdminEditScreenContainer;
